// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"OrderAlertModal_modalContainer__tyEcV","text":"OrderAlertModal_text__V_YPc"};